import * as z from 'zod';

export const TagSchema = z.object({
    "id": z.number(),
    "is_active": z.boolean(),
    "name": z.string()
});

export const TagPartialSchema = TagSchema.partial();
export type TagPartial = z.infer<typeof TagPartialSchema>;
export type Tag = z.infer<typeof TagSchema>;

export function newTag(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...TagSchema.parse({...data})
    };
}

export function parseTag(data: any, partial = false) {
    if (!partial) {
        return {
            ...TagSchema.parse(data)
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...TagPartialSchema.parse(data)
        };
    }
}
